// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { useEffect, useReducer } from 'react';
import { Resources } from '@shared/localizations/Resources';
export function useLocalize(...entries) {
    const [, forceUpdate] = useReducer((x) => x + 1, 0);
    useEffect(() => {
        Resources.subscribeOnLocaleChange(forceUpdate);
        return () => {
            Resources.unsubscribeOnLocaleChange(forceUpdate);
        };
    }, []);
    return entries.map((entry) => {
        if (typeof entry === 'string') {
            return Resources.getResource(entry);
        }
        const [key, placeholders] = entry;
        return Resources.getResource(key, placeholders);
    });
}
export function setPlaceholders(localizedText, placeholders) {
    return Resources.replacePlaceholders(localizedText, placeholders);
}
